import {
	VCard,
	VCardText,
	VCol,
	VContainer,
	VRow
} from "vuetify/lib";

export default {
	name: "DefaultLayout",

	props: {
		maxWidth: String
	},

	data: () => ( {
		docHeight: document.documentElement.clientHeight
	} ),

	computed: {
		isKiosk() {
			return this.$store.state.kiosk.isKiosk;
		},

		pageHeight() {
			if ( this.isKiosk ) {
				const topHeight = this.$vuetify.application.top + this.$vuetify.application.bar;

				return `${this.docHeight - topHeight}px`;
			}

			return null;
		},

		hasLeftSidebar() {
			return Boolean( this.$slots.leftSidebar );
		},

		hasRightSidebar() {
			return Boolean( this.$slots.rightSidebar );
		},

		numSidebars() {
			return Number( this.hasLeftSidebar ) + Number( this.hasRightSidebar );
		},

		internalMaxWidth() {
			if ( this.maxWidth ) {
				return this.maxWidth;
			}

			return `${600 + ( this.numSidebars * 500 )}px`;
		},

		sidebarSizeProps() {
			return {
				cols: 12,
				md: this.numSidebars === 2 ? 3 : 5,
				lg: this.numSidebars < 2 ? 4 : null
			};
		}
	},

	methods: {
		updateDocHeight() {
			this.docHeight = document.documentElement.clientHeight;
		}
	},

	render() {
		return <VContainer
			class="d-flex child-flex fill-height"
			fluid
			style={{
				"align-items": "start",
				height: this.pageHeight,
				maxWidth: this.internalMaxWidth
			}}
			vResize={this.updateDocHeight}
		>
			<VRow class="fill-height mx-auto">
				<VCol
					class={{
						"fill-height": true,
						"pa-0": !this.numSidebars
					}}
					orderMd={2}
				>
					{this.$slots.default}
				</VCol>

				{this.hasLeftSidebar && <VCol
					attrs={this.sidebarSizeProps}
					orderMd={1}
				>
					<VCard>
						<VCardText>
							{this.$slots.leftSidebar}
						</VCardText>
					</VCard>
				</VCol>}

				{this.hasRightSidebar && <VCol
					attrs={this.sidebarSizeProps}
					orderMd={3}
				>
					<VCard>
						<VCardText>
							{this.$slots.rightSidebar}
						</VCardText>
					</VCard>
				</VCol>}
			</VRow>
		</VContainer>;
	}
};
